import React, { FC, ReactElement, useCallback, useMemo, useState, useEffect } from 'react';
import { IconType } from '@om-fe/widgets/dist/components/icon/icon.constants';
import { createWidgetsBem } from '@om-fe/widgets/dist/common/bem/bem';
import { ItemWidthType, LayoutType } from "@om-fe/widgets/dist/components/nav/nav.constants";
import { NavStatic } from '@om-fe/widgets/dist/components/nav/static/nav-static';
import { NavStaticItemModel } from '@om-fe/widgets/dist/components/nav/static/nav-static.constants';
import { PopularLinksMenu } from '@om-fe/widgets/dist/widgets/menus/popular-links-menu/popular-links-menu';
import { FavoriteTournamentsMenu as FavoriteTournamentsMenuNormal } from '@om-fe/widgets/dist/widgets/menus/favorite-tournaments-menu/favorite-tournaments-menu';
import { SportsMenu } from '@om-fe/widgets/dist/widgets/menus/sports-menu/sports-menu';
import { WidgetsRouteChangeDetails, WidgetsRouteName, SportRouteParams } from '@om-fe/widgets/dist/common/routing/routing.constants';
import { UseSportsNavStore, useSportsNavTopicStoreCreator } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.hooks';
import { SportsNavType, SportsNavCounterType } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav.constants';
import { SportsNav } from '@om-fe/widgets/dist/widgets/navs/sports-nav/sports-nav';
import { TopBetsMatchesContent } from './top-bets-content-tabs';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';
import { connect } from 'react-redux';
import { AppState } from '@om-fe/core/core/types';
import { GeneralIconName, CounterType, DisciplinesType } from '@om-fe/models';
import { HomeTab, SportsMenuType } from './match-content-tabs.constants';
import { useParams } from 'react-router';
import { EventNavigationMenuSelectedDetails } from '@om-fe/widgets/dist/widgets/sports-menu/event-navigation-menu/event-navigation-menu.types';
import { getCurrentVirtualState, setVirtualStateExtraParams, VirtualStateModel } from '@om-fe/core/core/routing/custom-routes/custom-routes.utils';
import { RouteNames, RouteDetails } from '@om-fe/core/core/routing/utils';
import { scrollContainerToPosition } from '@om-fe/core/utils/dom';
import getConfig, { OMFE2ConfigModel, LeftSideBarConfig, SiteLinksConfig, BannerMatrixConfig } from '@om-fe/core/utils/config';
import { QuickLink, QuickLinkLayout } from '../quick-link/quick-link';
import { isBrowser, PlatformTypes, listenToMessageAll, ReceivedMessageType } from '@om-fe/utils';
import { TopBetsTab } from '../top-bets/utils/top-bets.constants';
import { AllSportsNavItem } from '@om-fe/core/components/sports-nav/all-sports-nav-item/all-sports-nav-item';
import SimpleSearchTrigger from '@om-fe/core/components/search/simple-search-trigger';
import { SearchPageComponent } from '@om-fe/core/pages/theme1/search-page';
import { SiteLinks } from '@om-fe/core/components/site-links/site-links';
import HelpSupportLinksCore from '@om-fe/core/pages/theme1/parts/help-support-links';
import HelpSupportLinksNDW from '../help-support-links/help-support-links';
import SettingsMenu from '@om-fe/core/pages/theme1/parts/settings-menu';
import BannermatrixBanner from '@om-fe/core/components/external-widgets/bannermatrix-banner';
import { useEMRouting } from '@om-fe/core/core/routing/with-routing';
import { getDisciplineRouteDetails } from '@om-fe/core/components/discipline-anchor/discipline-anchor.utils';
import { getDisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import FavoriteTournamentsMenuV2 from '../menu/favorite-tournament/favorite-tournament-menu';
import { FavoritesStoreState } from '@om-fe/core/components/favorite-button/favorite-state.constants';
import { FavoritesStoreState as FavoritesStoreStateV2 } from '@om-fe/core/components/favorite-events/favorite-state.constants';
import { favoriteSlice } from '@om-fe/core/components/favorite-button/favorite-state.store';
import {
    favoriteTeamsSlice,
    FavoriteTeamsStateModel,
} from '@om-fe/core/components/favorite-teams/favorite-teams.store';
import getSlice from '@om-fe/core/utils/get-slice';

const config: OMFE2ConfigModel = getConfig();
const specialBonusSingle: boolean = config?.specialBonus?.single;
const specialBonusMulti: boolean = config?.specialBonus?.multi;
const enableAllSportsNavItem: boolean = config?.enableAllSportsNavItem;
const leftSideBarConfig: LeftSideBarConfig | undefined = config.leftSideBar;
const siteLinks: boolean = leftSideBarConfig?.siteLinks || false;
const siteLinksConfig: SiteLinksConfig | undefined = leftSideBarConfig?.siteLinksConfig;
const helpSupportLinks: boolean = leftSideBarConfig?.helpSupportLinks || false;
const coreHelpSupportLinks: boolean = leftSideBarConfig?.coreHelpSupportLinks || false;
const settingsMenu: boolean = leftSideBarConfig?.settingsMenu || false;
const showPopularLinksDisciplineIcons: boolean = leftSideBarConfig?.popularLinksMenu?.showDisciplineIcons ?? true;
const enabledHorseRacing: boolean = config?.enabledHorseRacing ?? false;
const enabledGreyHound: boolean = config?.enabledGreyHound ?? false;
const bannerMatrixConfig: BannerMatrixConfig | undefined = config?.bannerMatrix;
const enabledDisciplinePage : boolean = config?.enabledDisciplinePage ?? false;
const disabledRacingTab: boolean = config?.disabledRacingTab ?? false;
const topicTimezoneOffset: boolean = config.matchListConfig?.topBets?.topicTimezoneOffset ?? false;
const favoriteV2Config: boolean = config.favoriteV2 ?? false;
const favoriteTeamsConfig: boolean = config.favorite?.showFavoriteTeams ?? false;
const enabledBetSimulate: boolean = config.simulate?.enabled ?? false;

enum MatchContentTabsIds {
    Popular = 'Popular',
    AllSports = 'AllSports',
}

const bem = createWidgetsBem({
    name: 'LiveUpcomingWrapper',
});

export interface RouteParams {
    readonly homeTab: string;
}

interface MatchContentTabsComponentStoreProps {
    readonly isSmall: boolean;
    readonly isMedium: boolean;
    readonly deviceType?: PlatformTypes;
    readonly favoriteTeams: number;
}

type MatchContentTabsComponentProps = MatchContentTabsComponentStoreProps;

function MatchContentTabsComponent({
    isSmall,
    isMedium,
    deviceType,
    favoriteTeams,
}: MatchContentTabsComponentProps): ReactElement {
    const { getFullPath } = useEMRouting();
    const { homeTab } = useParams<RouteParams>();
    const [selectedNavStaticContent, setSelectedNavStaticContent] = useState<MatchContentTabsIds>(MatchContentTabsIds.Popular);
    const { gettext } = useI18NContext();
    const [selectedSportsMenuType, setSportsMenuType] = useState<SportsMenuType>(SportsMenuType.None);
    const [selectedSportId, setSelectedSportId] = useState<string | undefined>();
    const [topSportsItemsLimit, setTopSportsItemsLimit] = useState<number | undefined>(undefined);
    const [selectedSportChild, setSelectedSportChild] = useState<string | undefined>(undefined);

    const getDistanceFromTop = useCallback((details: EventNavigationMenuSelectedDetails) => {
        if (isBrowser() && config.virtualState){
            let checkMenu: string = '';
            if (details.location) {
                checkMenu = `a[href*='/${details.sport}/'][href*='/${details.location}/']`;
            } else if (details.tournamentCategory) {
                checkMenu = `a[href*='/${details.sport}/'][href*='/${details.tournamentCategory}/']`;
            } else if (details.tournament) {
                checkMenu = `a[href$='/${details.tournament}`;
            }

            if (checkMenu) {
                const target: Element | null = document.querySelector(checkMenu);
                if (target) {
                    const rect: DOMRect = target.getBoundingClientRect();
                    setVirtualStateExtraParams({ focusMenuFromTop: rect.top });
                }
            }
        }
    }, []);

    const updateSelectedTopSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        const { sport, sportChild } = details;
        setSportsMenuType(SportsMenuType.TopSports);
        setVirtualStateExtraParams({
            selectedSportsMenuType: SportsMenuType.TopSports,
            selectedSportId: sport,
            selectedSportChild: sportChild,
        });
        setSelectedSportId(sport);
        setSelectedSportChild(sportChild);
        getDistanceFromTop(details);
    }, [getDistanceFromTop]);

    const updateSelectedAllSportsDetails = useCallback((details: EventNavigationMenuSelectedDetails) => {
        const { sport, sportChild } = details;
        setSportsMenuType(SportsMenuType.AllSports);
        setVirtualStateExtraParams({
            selectedSportsMenuType: SportsMenuType.AllSports,
            selectedSportId: sport,
            selectedSportChild: sportChild,
        });
        setSelectedSportId(sport);
        setSelectedSportChild(sportChild);
        getDistanceFromTop(details);
    }, [getDistanceFromTop]);

    const restoreMobilePosition = useCallback(() => {
        const virtualState: VirtualStateModel = getCurrentVirtualState();
        if (config.virtualState && virtualState && virtualState.extraParams?.selectedNavStaticContent === MatchContentTabsIds.AllSports) {
            setSelectedNavStaticContent(MatchContentTabsIds.AllSports);
            if (
                !virtualState.action &&
                virtualState.forwardState?.params &&
                virtualState.forwardState.params.disciplineId &&
                (virtualState.forwardState.name === RouteNames.tournament || virtualState.forwardState.name === RouteNames.tournamentLocation || virtualState.forwardState.name === RouteNames.tournamentCategories)
            ) {
                if (virtualState.extraParams?.selectedSportsMenuType === SportsMenuType.TopSports || virtualState.extraParams?.selectedSportsMenuType === SportsMenuType.AllSports) {
                    setSportsMenuType(virtualState.extraParams.selectedSportsMenuType);

                    if (virtualState.extraParams.selectedSportChild && virtualState.extraParams.selectedSportChild === virtualState.forwardState.params.disciplineId) {
                        setSelectedSportId(virtualState.extraParams.selectedSportId)
                        setSelectedSportChild(virtualState.extraParams.selectedSportChild);
                    } else {
                        setSelectedSportId(virtualState.forwardState.params.disciplineId);
                    }

                    let intervalCount = 0;
                    const intervalId = setInterval(() => {
                        const url: string = `${virtualState.forwardState.params.disciplineName}/${virtualState.forwardState.params.disciplineId}/${virtualState.forwardState.params.locationName || virtualState.forwardState.params.eventCategoryName}/${virtualState.forwardState.params.locationId || virtualState.forwardState.params.eventCategoryId}`;
                        const foundItem = !!document.querySelectorAll(`a[href*='${url}']`).length;

                        if (!foundItem) {
                            if (topSportsItemsLimit !== 999) {
                                setTopSportsItemsLimit(999);
                            }
                        } else {
                            clearInterval(intervalId);
                            scrollContainerToPosition(`a[href*='${url}']`, virtualState.extraParams?.focusMenuFromTop || 'center');
                        }

                        intervalCount++;
                        if (intervalCount > 30) {
                            clearInterval(intervalId);
                        }
                    }, 200);
                }
            }
        } else if (homeTab === HomeTab.AllSports) {
            setSelectedNavStaticContent(MatchContentTabsIds.AllSports);
        }
    }, [homeTab, topSportsItemsLimit]);

    useEffect(() => {
        if (isBrowser() && config.virtualState) {
            let virtualStateListenerUnsubscribe:() => void;
            virtualStateListenerUnsubscribe = listenToMessageAll(ReceivedMessageType.VirtualStateTrigger, () => {
                if (isSmall || isMedium) {
                    restoreMobilePosition();
                }
            });

            return () => {
                if (virtualStateListenerUnsubscribe) {
                    virtualStateListenerUnsubscribe();
                }
            };
        }
    }, [isMedium, isSmall, restoreMobilePosition]);

    useEffect(() => {
        setVirtualStateExtraParams({ selectedNavStaticContent: selectedNavStaticContent });
    }, [selectedNavStaticContent]);

    const items = useMemo((): NavStaticItemModel<MatchContentTabsIds>[] => {
        let matchContentTabsIds: NavStaticItemModel<MatchContentTabsIds>[] = [
            {
                id: MatchContentTabsIds.Popular,
                text: gettext('Top Bets'),
                iconType: IconType.General,
                iconName: 'hot',
            },
        ];

        if (isSmall || isMedium) {
            matchContentTabsIds = [
                ...matchContentTabsIds,
                {
                    id: MatchContentTabsIds.AllSports,
                    text: gettext('All Sports'),
                    iconType: IconType.General,
                    iconName: 'view-list-alt',
                }
            ];
            restoreMobilePosition();
        } else {
            setSelectedNavStaticContent(MatchContentTabsIds.Popular);
        }

        return matchContentTabsIds;
    }, [gettext, isSmall, isMedium, restoreMobilePosition]);

    const specialEnabledInSportNav: boolean = config?.specialBonus?.enabledInSportNav;
    const [sportId, setSportId] = useState<undefined | string>();
    const [allSportsIsSelected, setAllSportsIsSelected] = useState<boolean>(false);
    const enableBonusTab: boolean = (specialEnabledInSportNav && (specialBonusSingle || specialBonusMulti)) ? true : false;
    const bannerNav: boolean | undefined = bannerMatrixConfig?.showOnNavbar ?? false;
    const bannerNav2: boolean | undefined = bannerMatrixConfig?.showOnSecondNavbar ?? false;
    const bannerNav3: boolean | undefined = bannerMatrixConfig?.showOnThirdNavbar ?? false;
    const bannerNav4: boolean | undefined = bannerMatrixConfig?.showOnFourthNavbar ?? false;

    const showNavbarBanners: boolean = deviceType !== 'desktop';

    const bannerContent: React.ReactNode = useMemo(() => bannerNav && showNavbarBanners
        ? (<BannermatrixBanner
            className="BannerNavbar BannerWidgetColorPack"
            pageTag="home-page"
            positionTag="center-navbar"
        />)
        : null, [bannerNav, showNavbarBanners]);

    const bannerContent2: React.ReactNode = useMemo(() => bannerNav2 && showNavbarBanners
        ? (<BannermatrixBanner
            className="BannerNavbar BannerWidgetColorPack"
            pageTag="home-page"
            positionTag="center-navbar-2"
        />)
        : null, [bannerNav2, showNavbarBanners]);

    const bannerContent3: React.ReactNode = useMemo(() => bannerNav3 && showNavbarBanners
        ? (<BannermatrixBanner
            className="BannerNavbar BannerWidgetColorPack"
            pageTag="home-page"
            positionTag="center-navbar-3"
        />)
        : null, [bannerNav3, showNavbarBanners]);

    const bannerContent4: React.ReactNode = useMemo(() => bannerNav4 && showNavbarBanners
        ? (<BannermatrixBanner
            className="BannerNavbar BannerWidgetColorPack"
            pageTag="home-page"
            positionTag="center-navbar-4"
        />)
        : null, [bannerNav4, showNavbarBanners]);

    const useStore: UseSportsNavStore = useSportsNavTopicStoreCreator({
        sportsNavType: SportsNavType.TopBets,
        showOnlySportsWithMatches: true,
        counterType: SportsNavCounterType.NumberOfEvents,
        showFromAPI: true,
        hasBonus: enableBonusTab,
        hasHorseRacing: !disabledRacingTab && enabledHorseRacing,
        hasGreyHound: !disabledRacingTab && enabledGreyHound,
        hasBanner: bannerNav && showNavbarBanners ? true : false,
        hasBanner2: bannerNav2 && showNavbarBanners ? true : false,
        hasBanner3: bannerNav3 && showNavbarBanners ? true : false,
        hasBanner4: bannerNav4 && showNavbarBanners ? true : false,
        topicTimezoneOffset,
        favorites: favoriteTeams,
        enabledBetSimulate,
    });

    const onItemClick = useCallback((itemData: WidgetsRouteChangeDetails<WidgetsRouteName.Sport>): void => {
        const { params: { sportId: newSportId } } = itemData;
        setSportId(newSportId);
        setSelectedSportId(newSportId);
        setVirtualStateExtraParams({ sportId: newSportId, locationId: TopBetsTab.TopBets, timeRangeId: undefined, matchLimit: 0 });
        setSelectedNavStaticContent(MatchContentTabsIds.Popular);
    }, []);

    const handleClickAllSports = useCallback(() => {
        setSportId(undefined);
        setSelectedNavStaticContent(MatchContentTabsIds.AllSports);
        setAllSportsIsSelected(true);
    }, []);

    useEffect(() => {
        if (selectedNavStaticContent === MatchContentTabsIds.AllSports && !sportId) {
            setAllSportsIsSelected(true);
        }
    }, [sportId, selectedNavStaticContent]);

    const generateSportsPageUrl = useCallback((params: SportRouteParams): string | undefined => {
        const routeDetails: RouteDetails = getDisciplineRouteDetails({
            childId: params.childSportId,
            childName: params.childSportName,
            disciplineId: params.sportId,
            disciplineName: params.sportName,
            isLive: false,
            disciplineRouteType: getDisciplineRouteType(params),
            gettext,
        });

        return getFullPath(routeDetails.routeName, routeDetails.routeParams);
    }, [getFullPath, gettext]);

    const renderNavStaticContent = useMemo(() => {
        const virtualSportRoute = getFullPath(RouteNames.newVirtualSports);

        switch (selectedNavStaticContent) {
            case MatchContentTabsIds.Popular:
                return (
                    <TopBetsMatchesContent
                        handleClickAllSports={handleClickAllSports}
                        allSportsIsSelected={false}
                        useStore={useStore}
                        bannerContent={bannerContent}
                        bannerContent2={bannerContent2}
                        bannerContent3={bannerContent3}
                        bannerContent4={bannerContent4}
                        selectedSportId={sportId}
                    />
                );
            case MatchContentTabsIds.AllSports:
                const FavoriteTournamentsMenu = (() => {
                    if (config.favoriteV2) {
                        return FavoriteTournamentsMenuV2;
                    }

                    return FavoriteTournamentsMenuNormal;
                })();

                return (isSmall || isMedium)
                    ? (
                        <>
                            {enableAllSportsNavItem &&
                                <>
                                    <div className={'NavWrapper'}>
                                        <SportsNav
                                            activeItemId={sportId}
                                            sportRoute={false}
                                            virtualSportRoute={virtualSportRoute}
                                            onRouteChange={onItemClick}
                                            useStore={useStore}
                                            className={`${SportsNavType.Popular}SportsNav`}
                                            showIcon
                                            hasArrows={deviceType === 'desktop'}
                                            layoutType={LayoutType.Main}
                                            allSportsNavItemComponent={
                                                <AllSportsNavItem
                                                    handleClick={handleClickAllSports}
                                                    isSelected={allSportsIsSelected}
                                                />
                                            }
                                            disableEsportNavItem={config.layout?.disableEsportNavItem}
                                            disableNavItemById={[DisciplinesType.Olympics]}
                                            bannerContent={bannerContent}
                                            bannerContent2={bannerContent2}
                                            bannerContent3={bannerContent3}
                                            bannerContent4={bannerContent4}
                                        />
                                    </div>
                                    <div className={'AllSportsNavItemSearch'}>
                                        <SimpleSearchTrigger
                                            defaultSearchMap={SearchPageComponent.defaultSearchMap}
                                            searchRouteName={RouteNames.search}
                                            searchPlaceholder={gettext('Search')}
                                        />
                                    </div>
                                </>
                            }
                            <div className='MobileMenu'>
                                {siteLinks &&
                                    <SiteLinks
                                        deviceType={deviceType}
                                        disableNextEvents={siteLinksConfig?.disableNextEvents ?? false}
                                        disablePopularEvents={siteLinksConfig?.disablePopularEvents ?? false}
                                    />
                                }
                                <FavoriteTournamentsMenu
                                    widgetTitle={gettext('Favorite Tournaments')}
                                    headerIconName={GeneralIconName.Link}
                                    showDisciplineIcons={true}
                                    enabledHorseRacing={enabledHorseRacing}
                                    enabledGreyHound={enabledGreyHound}
                                />
                                <PopularLinksMenu
                                    widgetTitle={gettext('Popular')}
                                    headerIconName={GeneralIconName.Link}
                                    showDisciplineIcons={showPopularLinksDisciplineIcons}
                                    enabledHorseRacing={enabledHorseRacing}
                                    enabledGreyHound={enabledGreyHound}
                                />
                                {(specialBonusSingle || specialBonusMulti) && (
                                    <QuickLink layout={QuickLinkLayout.Tab} />
                                )}
                                <SportsMenu
                                    controlledSelection
                                    sportRoute={enabledDisciplinePage ? generateSportsPageUrl : false}
                                    virtualSportRoute={virtualSportRoute}
                                    selectedSport={selectedSportsMenuType === SportsMenuType.TopSports ? selectedSportId : ''}
                                    selectedSportChild={selectedSportsMenuType === SportsMenuType.TopSports ? selectedSportChild : ''}
                                    displayShortTournamentName={true}
                                    widgetTitle={gettext('Top Sports')}
                                    itemsLimit={topSportsItemsLimit}
                                    counterType={CounterType.numberOfEvents}
                                    headerIconName={GeneralIconName.ViewList}
                                    showTopSportsOnly={true}
                                    hideTournament={true}
                                    onSelectedDetailsChange={updateSelectedTopSportsDetails}
                                    showMoreText={gettext('Show More')}
                                    showLessIcon={'minus'}
                                    showMoreIcon={'plus'}
                                    supportTournamentNav={true}
                                    enabledBetSimulate={enabledBetSimulate}
                                />
                                <SportsMenu
                                    controlledSelection
                                    sportRoute={enabledDisciplinePage ? generateSportsPageUrl : false}
                                    virtualSportRoute={virtualSportRoute}
                                    selectedSport={selectedSportsMenuType === SportsMenuType.AllSports ? selectedSportId : ''}
                                    selectedSportChild={selectedSportsMenuType === SportsMenuType.AllSports ? selectedSportChild : ''}
                                    displayShortTournamentName={true}
                                    widgetTitle={gettext('All Sports')}
                                    itemsLimit={999}
                                    counterType={CounterType.numberOfEvents}
                                    headerIconName={GeneralIconName.ViewList}
                                    hideTournament={true}
                                    onSelectedDetailsChange={updateSelectedAllSportsDetails}
                                    showMoreText={gettext('Show More')}
                                    showLessIcon={'minus'}
                                    showMoreIcon={'plus'}
                                    excludeTopSports={true}
                                    supportTournamentNav={true}
                                    displayShowMoreButton={false}
                                    enabledBetSimulate={enabledBetSimulate}
                                />
                                {helpSupportLinks && (coreHelpSupportLinks
                                    ? <HelpSupportLinksCore />
                                    : <HelpSupportLinksNDW />
                                )}
                                {!helpSupportLinks && settingsMenu &&
                                    <SettingsMenu />
                                }
                            </div>
                        </>
                    )
                    : null;
        }
    }, [
        selectedNavStaticContent,
        handleClickAllSports,
        useStore,
        bannerContent,
        bannerContent2,
        bannerContent3,
        bannerContent4,
        isSmall,
        isMedium,
        sportId,
        onItemClick,
        deviceType,
        allSportsIsSelected,
        gettext,
        selectedSportsMenuType,
        selectedSportId,
        selectedSportChild,
        topSportsItemsLimit,
        updateSelectedTopSportsDetails,
        updateSelectedAllSportsDetails,
        generateSportsPageUrl,
        enabledBetSimulate,
    ]);

    return (
        <>
            {!enableAllSportsNavItem &&
                <div className={bem({
                    modifiers: {
                        AllSportsContentActive: selectedNavStaticContent === MatchContentTabsIds.AllSports,
                        PopularMatchesContentActive: selectedNavStaticContent === MatchContentTabsIds.Popular,
                    },
                })}>
                    <NavStatic<MatchContentTabsIds>
                        items={items}
                        hasArrows={false}
                        itemWidthType={ItemWidthType.ItemFullEqualWidth}
                        layoutType={LayoutType.SingleRow}
                        className="LiveUpcomingNav"
                        activeItemId={selectedNavStaticContent}
                        onActiveItemChange={setSelectedNavStaticContent}
                    />
                </div>
            }
            {renderNavStaticContent}
        </>
    );
}

export const MatchContentTabs: FC = connect(
    (state: AppState): MatchContentTabsComponentStoreProps => {
        const favorites: FavoritesStoreState | FavoritesStoreStateV2 | undefined = getSlice<FavoritesStoreState | FavoritesStoreStateV2>(state, favoriteSlice);
        const favoriteTeams: FavoriteTeamsStateModel | undefined = getSlice<FavoriteTeamsStateModel>(state, favoriteTeamsSlice);

        let countFavoriteTeams = 0;
        if (favoriteV2Config && favorites){
            countFavoriteTeams += Object.keys(favorites.favoriteMatchItems).length;
        }

        if (favoriteTeamsConfig && favoriteTeams) {
            countFavoriteTeams += favoriteTeams?.list ? favoriteTeams.list.length : 0;
        }

        return {
            isSmall: !!state.breakpoints.small,
            isMedium: !!state.breakpoints.medium,
            deviceType: state.deviceInfo?.platform.type,
            favoriteTeams: countFavoriteTeams,
        };
    },
)(MatchContentTabsComponent);
